module.exports = __webpack_public_path__ + "static/media/moblieview_img1.d34d07a5.png";